//
// Auth
//
export function userAuthenticated ({ auth }) {
  return !!auth.token
}

export function authenticatedUser ({ auth }) {
  return auth.user
}

//
// Users
//
export function users ({ users }) {
  return users.all
}

export function user ({ users }) {
  return users.user
}

//
// Meetings
//
export function meetings ({ meetings }) {
  return meetings.all
}

export function meetingsContact ({ meetings }) {
  return meetings.meetingContact
}

export function meetingsProject ({ meetings }) {
  return meetings.meetingProject
}

export function meeting ({ meetings }) {
  return meetings.meeting
}

export function meetingCreated ({ meetings }) {
  return meetings.meetingCreated
}

export function meetingUpdated ({ meetings }) {
  return meetings.meetingUpdated
}

export function meetingDeleted ({ meetings }) {
  return meetings.meetingDeleted
}

export function selectedDay ({ meetings }) {
  return meetings.selectedDay
}

export function selectedUsers ({ meetings }) {
  return meetings.selectedUsers
}

//
// Countries
//
export function countries ({ countries }) {
  return countries.all
}

// Phases
//
export function phases ({ phases }) {
  return phases.all
}

// Contents
//
export function contents ({ contents }) {
  return contents.all
}

// Places
//
export function places ({ places }) {
  return places.all
}

// Trainings
//
export function trainings ({ trainings }) {
  return trainings.all
}

// Presences
//
export function presences ({ presences }) {
  return presences.all
}

// Intervenant 1
//
export function firstintervenants ({ firstintervenants }) {
  return firstintervenants.all
}

//
// Sub sectors
//
export function subSectors ({ subSectors }) {
  return subSectors.all
}

//
// Gooogle
//
export function googleOAuthUrl ({ google }) {
  return google.authUrl
}

export function googleOauthConnected ({ google }) {
  return !!google.token
}

export function googleOAuthToken ({ google }) {
  return google.token
}

//
// Contacts
//
export function contacts ({ contacts }) {
  return contacts.all
}

export function contact ({ contacts }) {
  return contacts.contact
}

export function socialStatusesOfContact ({ contacts }) {
  return contacts.socialStatusesOfContact
}

export function contractTypesOfContact ({ contacts }) {
  return contacts.contractTypesOfContact
}

export function problematiquesOfContact ({ contacts }) {
  return contacts.problematiquesOfContact
}

export function projectsOfContact ({ projectsOfContact }) {
  return projectsOfContact.all
}
//
// Issues
//
export function issues ({ issues }) {
  return issues.all
}

//
// Family situations
//
export function familySituations ({ familySituations }) {
  return familySituations.all
}

//
// Partner situations
//
export function partnerSituations ({ partnerSituations }) {
  return partnerSituations.all
}

//
// Social statuses
//
export function socialStatuses ({ socialStatuses }) {
  return socialStatuses.all
}

//
// Social statuses
//
export function contractTypes ({ contractTypes }) {
  return contractTypes.all
}

//
// Problematiques
//
export function problematiques ({ problematiques }) {
  return problematiques.all
}

//
// Allowances
//
export function allowances ({ allowances }) {
  return allowances.all
}

//
// Sectors
//
export function sectors ({ sectors }) {
  return sectors.all
}

//
// Incubator Rewards
//
export function incubatorRewards ({ incubatorRewards }) {
  return incubatorRewards.all
}

//
// Education levels
//
export function educationLevels ({ educationLevels }) {
  return educationLevels.all
}

//
// Tracking places
//
export function trackingPlaces ({ trackingPlaces }) {
  return trackingPlaces.all
}

//
// Referent Advisers
//
export function referentAdvisers ({ referentAdvisers }) {
  return referentAdvisers.all
}

//
// Companies
//
export function companies ({ companies }) {
  return companies.all
}

export function companiesRequestError ({ companies }) {
  return companies.error
}

export function jobs ({ jobs }) {
  return jobs.all
}

export function jobsRequestError ({ jobs }) {
  return jobs.error
}

export function courses ({ courses }) {
  return courses.all
}

export function coursesRequestError ({ courses }) {
  return courses.error
}

export function courseTypes ({ courseTypes }) {
  return courseTypes.all
}

export function structureTypes ({ structureTypes }) {
  return structureTypes.all
}

export function statutEntrepreneurs ({ statutEntrepreneurs }) {
  return statutEntrepreneurs.all
}

export function taxRegimes ({ taxRegimes }) {
  return taxRegimes.all
}

export function welfareRegimes ({ welfareRegimes }) {
  return welfareRegimes.all
}

export function employments ({ employments }) {
  return employments.all
}
//
// Projects
//
export function projects ({ projects }) {
  return projects.all
}

export function project ({ projects }) {
  return projects.project
}

export function projectTypes ({ projectTypes }) {
  return projectTypes.all
}
export function projectStatus ({ projectStatus }) {
  return projectStatus.all
}

export function capes ({ capes }) {
  return capes.all
}
export function cape ({ capes }) {
  return capes.cape
}

export function capesRequestError ({ capes }) {
  return capes.error
}

export function cers ({ cers }) {
  return cers.all
}

/* export function cer ({ cers }) {
  return cers.cer
} */

export function cersRequestError ({ cers }) {
  return cers.error
}
export function sortie ({ sorties }) {
  return sorties.sortie
}
export function sorties ({ sorties }) {
  return sorties.all
}

export function sortiesRequestError ({ sorties }) {
  return sorties.error
}
export function club ({ clubs }) {
  return clubs.club
}

export function clubsRequestError ({ clubs }) {
  return clubs.error
}
export function cae ({ caes }) {
  return caes.cae
}

export function caesRequestError ({ caes }) {
  return caes.error
}

export function instructors ({ instructors }) {
  return instructors.all
}

export function prescriptors ({ prescriptors }) {
  return prescriptors.all
}




// WEBPACK FOOTER //
// ./src/vuex/getters.js